export default {
  /** Promise */
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  },
  isDebug() {
    return process.env.NODE_ENV == "debug";
  }
};
